<markdown class="markdown" *ngIf="md$ | async as md">{{ md }}</markdown>
<div class="footer-spacing"></div>
